// src/utils/jwt.js

/**
 * Decodifica el payload de un JWT (sin verificar firma — eso es cosa del backend).
 * Solo lee los claims para saber cuándo expira. Devuelve el objeto payload o null.
 */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const partes = token.split('.');
  if (partes.length !== 3) return null;
  try {
    // base64url -> base64 -> JSON
    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Milisegundos que faltan para que el token expire.
 * - Devuelve un número > 0 si aún es válido.
 * - Devuelve 0 o negativo si ya expiró.
 * - Devuelve null si el token no tiene 'exp' (no se puede saber).
 */
export function msHastaExpiracion(token) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  // exp viene en segundos (estándar JWT); Date.now() en ms.
  return payload.exp * 1000 - Date.now();
}

/** ¿El token ya expiró? true si venció o es inválido con exp. */
export function tokenExpirado(token) {
  const ms = msHastaExpiracion(token);
  if (ms === null) return false; // sin exp: no podemos afirmar que expiró
  return ms <= 0;
}